import { Body1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { type TRatingSource } from './types';

import styles from './RatingsSources.css';

type TSourcesProps = {
  source: TRatingSource;
};

export const RatingsSources: FC<TSourcesProps> = ({ source }) => {
  return (
    <Body1 data-testid="RatingsSources">
      Все рейтинги можно посмотреть на&nbsp;
      <a
        className={styles['source-link']}
        data-testid="RatingsSources-link"
        href={source.url}
        rel="noreferrer"
        target="_blank"
      >
        сайте
      </a>
    </Body1>
  );
};
